import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Link } from "@natera/navigation";
import acknowledgements from "@etc/acknowledgements.json";

import "./terms.scss";

const messages = defineMessages({
  acknowledgementsText: {
    id: "acknowledgementsText",
    defaultMessage:
      "By continuing, you are accepting our {termsOfUse} and {privacyPolicy}",
  },
  termsOfUseText: {
    id: "termsOfUseText",
    defaultMessage: "Terms of Use",
  },
  privacyPolicyText: {
    id: "privacyPolicyText",
    defaultMessage: "Privacy Policy",
  },
});

export const Terms: FC = () => {
  const intl = useIntl();

  return (
    <section className="conditions__container">
      <span className="acknowledgements__text">
        {intl.formatMessage(messages.acknowledgementsText, {
          termsOfUse: (
            <Link
              to={acknowledgements.links.termsOfUse}
              key="termsOfUse"
              target="_blank"
              rel="noreferrer"
            >
              {intl.formatMessage(messages.termsOfUseText)}
            </Link>
          ),
          privacyPolicy: (
            <Link
              to={acknowledgements.links.privacyPolicy}
              key="privacyPolicy"
              target="_blank"
              rel="noreferrer"
            >
              {intl.formatMessage(messages.privacyPolicyText)}
            </Link>
          ),
        })}
      </span>
    </section>
  );
};
